import React from 'react'
import traitStyles from '../../Trait/Trait.module.scss'

import { t } from 'ttag'
import { Box } from 'components/layout/Box/Box'
import { Scale } from 'components/shared/DoubleEndedScale/Scale'
import { getPersonality } from '../../helpers'
import { CandidateSelect } from 'components/modals/TestsReportModal/common/CandidateSelect/CandidateSelect'
import { CautionSign } from 'components/shared/CautionSign/CautionSign'
import { hasCaution } from '../../cautions'

export const PersonalityOverview = ({
  language,
  factors,
  scores,
  setPersonalityTab,
  selectedCandidates,
  setSelectedCandidates,
  response,
  single,
  name,
  candidates,
  cautions = [],
}) => {
  const traits = factors.map(({ factor, label, id }) => ({
    id,
    label,
    caution: hasCaution(cautions, factor),
    score: Math.round(scores[0][factor] * 100),
    scores: response.map(resp => ({
      id: resp.id,
      score: Math.round(resp.scores[factor] * 100),
    })),
  }))

  const personalityDescriptions = getPersonality(language)

  return (
    <Box className={traitStyles.trait}>
      <div className={traitStyles.leftSection}>
        <div className={traitStyles.title}>
          <div>{t`Personality`}</div>
          {single ? <div className={traitStyles.name}>{name}</div> : null}
        </div>

        {single ? null : (
          <div className={traitStyles.select}>
            <CandidateSelect
              {...{
                candidates,
                selectedCandidates,
                setSelectedCandidates,
              }}
              disabled={traits[0].scores.reduce(
                (acc, trait) => ({ ...acc, [trait.id]: isNaN(trait.score) }),
                {},
              )}
            />
          </div>
        )}

        <div className={traitStyles.paragraph}>
          {personalityDescriptions[0]}
        </div>

        <div className={traitStyles.paragraphTitle}>
          {t`Interpreting the Results`}
        </div>

        <div className={traitStyles.paragraph}>
          {personalityDescriptions[1]}
        </div>

        <div className={traitStyles.paragraph}>
          {personalityDescriptions[2]}
        </div>
      </div>
      <div className={traitStyles.rightSection}>
        <div className={traitStyles.traitScales}>
          {traits.map(({ label, scores, id, caution }) => (
            <div
              className={traitStyles.traitScale}
              key={id}
              onClick={() => setPersonalityTab(id)}
            >
              <div className={traitStyles.traitScaleLabel}>
                {label}
                {caution ? <CautionSign placement="bottom" /> : null}
              </div>
              <div className={traitStyles.scale}>
                <Scale
                  single={single}
                  scores={scores}
                  selectedCandidates={selectedCandidates}
                  withHighlight={false}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Box>
  )
}
